import React, { useEffect } from 'react';
import { HotkeyBadge } from 'pages/Tagging/components/HotkeyBadge/HotkeyBadge';
import { ReactComponent as ForwardIcon } from 'components/icons/forward.svg';
import { useInjection } from 'services/ioc/ioc.react';
import { ServiceTypes } from 'constants/ServiceTypes';
import { HotkeyService } from 'services/helper-services/HotkeyService';
import { DisplayName, OptionWrapper } from './OptionStyles';
import { ReactComponent as TooltipIcon } from 'images/tooltipIcon.svg';
import { Tooltip } from '@mui/material';

interface IProps {
  displayName: any;
  isRecommended?: boolean;
  hotkeyDisplay: string | React.ReactElement;
  hotkeyCode: number;
  value: string | number;
  onPressHotkeyCallback?: (value: string | number, displayValue: string) => void;
  onClickCallBack?: (value: string | number, displayValue: string) => void;
  disabled?: boolean;
  selected?: boolean;
  isBattingPractice?: boolean;
  ['data-testid']?: string;
  tooltipContent?: JSX.Element;
}

export const Option: React.FC<IProps> = (props) => {
  const {
    displayName,
    isRecommended,
    hotkeyDisplay,
    hotkeyCode,
    value,
    onPressHotkeyCallback,
    onClickCallBack,
    disabled,
    selected,
    isBattingPractice,
    tooltipContent,
    ...rest
  } = props;
  const hotkeyService = useInjection<HotkeyService>(ServiceTypes.HotkeyService);

  useEffect(() => {
    if (onPressHotkeyCallback && !disabled) {
      hotkeyService.subscribe(hotkeyCode, onPressHotkey, displayName);
    }

    return () => {
      hotkeyService.unsubscribe(displayName);
    };
  }, [onPressHotkeyCallback, disabled]);

  const onPressHotkey = (event: KeyboardEvent) => {
    onPressHotkeyCallback && onPressHotkeyCallback(value, displayName);
    return false;
  };

  return (
    <OptionWrapper
      className={`${disabled ? ' disabled' : ''}${selected ? ' selected' : ''}`}
      onClick={() => onClickCallBack && !disabled && onClickCallBack(value, displayName)}
      {...rest}
    >
      <DisplayName>
        {displayName}
        {isRecommended ? 'Recommended' : ''}
        {tooltipContent && (
          <Tooltip title={tooltipContent} arrow classes={{ tooltip: 'tagging-flow-tooltip' }}>
            <TooltipIcon />
          </Tooltip>
        )}
      </DisplayName>
      <div>
        {hotkeyCode !== -1 && <HotkeyBadge hotkey={hotkeyDisplay} />}
        {!isBattingPractice && <ForwardIcon />}
      </div>
    </OptionWrapper>
  );
};
